import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-column xl:flex-row xl:align-items-start p-8 mt-8" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "formgrid grid justify-content-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "md:col-10 sm:col-12 lg:col-5 xl:col-5 px-4 font-normal" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "reset_mensaje" }, "¿Olvido su contraseña?"),
    /*#__PURE__*/_createElementVNode("div", { class: "pt-5 reset_font_s_20" }, " Introduzca la dirección de correo electrónico para recuperar su contraseña. ")
  ])
], -1)
const _hoisted_7 = { class: "md:col-10 sm:col-12 lg:col-5 xl:col-5 pt-5" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "formgrid grid" }
const _hoisted_10 = { class: "field col-12 md:col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, " Correo electrónico ", -1)
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "field col-12 md:col-12" }
const _hoisted_14 = { class: "pt-2" }
const _hoisted_15 = { class: "field col-12 md:col-12 lg:col-6 sm:col-12 xl:col-6" }
const _hoisted_16 = { class: "field col-12 md:col-12 lg:col-6 sm:col-12 xl:col-6" }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { class: "formgrid grid justify-content-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "md:col-10 sm:col-12 lg:col-5 xl:col-5 px-4 font-normal" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "reset_mensaje" }, "Restablecimiento de contraseña"),
    /*#__PURE__*/_createElementVNode("div", { class: "pt-5 reset_font_s_20" }, " Su contraseña será restablecida ")
  ])
], -1)
const _hoisted_20 = { class: "md:col-10 sm:col-12 lg:col-5 xl:col-5 pt-5" }
const _hoisted_21 = { class: "card" }
const _hoisted_22 = { class: "formgrid grid" }
const _hoisted_23 = { class: "field col-12 md:col-12" }
const _hoisted_24 = { class: "flex-1 flex justify-content-center pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Message = _resolveComponent("Message")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_CaptchaCanvas = _resolveComponent("CaptchaCanvas")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Toast),
      (_ctx.mostrar_error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(), _createBlock(_component_Message, {
              modelValue: _ctx.msg,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.msg) = $event)),
              severity: _ctx.msg.severity,
              key: _ctx.msg.content
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.msg.content), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "severity"]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.cargar)
        ? (_openBlock(), _createBlock(_component_spinner, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.enviar_mail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode(_component_InputText, {
                        id: "email",
                        modelValue: _ctx.state.mail,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.mail) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        class: "w-full"
                      }, null, 8, ["modelValue"]),
                      (_ctx.v$.mail.$error)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.mail.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_CaptchaCanvas, {
                          ref: "captchaRef",
                          captchaValid: _ctx.captchaValida
                        }, null, 8, ["captchaValid"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        to: "/",
                        custom: ""
                      }, {
                        default: _withCtx(({ navigate }) => [
                          _createVNode(_component_Button, {
                            label: "Cancelar",
                            class: "p-button p-button-secondary w-12 justify-content-center border-round p-3 text-white",
                            onClick: navigate,
                            role: "link"
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_Button, {
                        id: "btn_env_mail",
                        label: "Restablecer cuenta",
                        class: "p-button w-12 justify-content-right border-round p-3 text-white",
                        onClick: _ctx.submit_correo
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.enviar_mail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, " Se envío un link al correo electrónico " + _toDisplayString(_ctx.state.mail) + " para restablecer su cuenta. Al hacer clic en el link del correo deberá ingresar su nueva contraseña. ", 1),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_router_link, {
                        to: "/",
                        custom: ""
                      }, {
                        default: _withCtx(({ navigate }) => [
                          _createVNode(_component_Button, {
                            class: "p-button border-round p-3 text-white",
                            onClick: navigate,
                            label: "Aceptar",
                            role: "link"
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}